
export default {
  props: {
    label: {
      required: true,
      type: String,
    },
  },
}
